import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
import { api, ApiError } from '@/lib/api-client';
import { AuthShell } from '@/components/AuthShell';
/** Page ouverte depuis le lien de confirmation envoyé aux citoyens inscrits sur l'application mobile. */
export function VerifyEmailPage() {
    const [params] = useSearchParams();
    const token = params.get('token') ?? '';
    const [state, setState] = useState('pending');
    const [message, setMessage] = useState('');
    const started = useRef(false);
    useEffect(() => {
        if (started.current)
            return;
        started.current = true;
        if (!token) {
            setState('error');
            setMessage('Lien incomplet.');
            return;
        }
        api.auth
            .verifyEmail(token)
            .then(() => setState('ok'))
            .catch((err) => {
            setState('error');
            setMessage(err instanceof ApiError ? err.message : 'Lien invalide ou expiré.');
        });
    }, [token]);
    return (_jsxs(AuthShell, { title: "Confirmation du courriel", children: [state === 'pending' && (_jsxs("div", { className: "flex items-center gap-2 text-sm text-muted-foreground", children: [_jsx(Loader2, { className: "size-4 animate-spin" }), "V\u00E9rification en cours\u2026"] })), state === 'ok' && (_jsxs("div", { className: "flex items-start gap-3 rounded-md border border-border bg-muted/50 p-4 text-sm", children: [_jsx(CheckCircle2, { className: "mt-0.5 size-5 shrink-0 text-status-resolved" }), _jsx("p", { children: "Votre adresse est confirm\u00E9e. Vous pouvez retourner dans l'application CI-VILLE et envoyer vos signalements." })] })), state === 'error' && (_jsxs("div", { className: "flex items-start gap-3 rounded-md border border-border bg-muted/50 p-4 text-sm", children: [_jsx(XCircle, { className: "mt-0.5 size-5 shrink-0 text-destructive" }), _jsxs("p", { children: [message, " Demandez un nouveau lien depuis l'application."] })] }))] }));
}
//# sourceMappingURL=VerifyEmailPage.js.map